import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PipelineDashboardComponent } from './pipeline-dashboard/pipeline-dashboard.component';
import { DefaultComponent } from './default/default.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultComponent
  },
  {
    path: 'api/default',
    component: DefaultComponent
  },
  {
    path: 'PipelineDashboard/:id',
    component: PipelineDashboardComponent,
    data: {
      title: 'Pipeline Dashboard'
    }
  },
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
